"use strict";

var _regeneratorRuntime = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */

if (process.env.NODE_ENV !== "test") {
  require("source-map-support").install();
}

var url_1 = require("url");

var htmlparser2_1 = require("htmlparser2");

var cross_fetch_1 = require("cross-fetch");

var unexpectedError_1 = require("./unexpectedError");

var schema_1 = require("./schema");

var he_1 = require("he");

var iconv_lite_1 = require("iconv-lite");

function unfurl(url, opts) {
  if (opts === undefined) {
    opts = {};
  }

  if (opts.constructor.name !== "Object") {
    throw new unexpectedError_1.default(unexpectedError_1.default.BAD_OPTIONS);
  }

  typeof opts.oembed === "boolean" || (opts.oembed = true);
  typeof opts.compress === "boolean" || (opts.compress = true);
  typeof opts.userAgent === "string" || (opts.userAgent = "facebookexternalhit");
  Number.isInteger(opts.follow) || (opts.follow = 50);
  Number.isInteger(opts.timeout) || (opts.timeout = 0);
  Number.isInteger(opts.size) || (opts.size = 0);
  var ctx = {
    url: url
  };
  return getPage(url, opts).then(getMetadata(ctx, opts)).then(getRemoteMetadata(ctx, opts)).then(parse(ctx));
}

exports.unfurl = unfurl;

function getPage(_x, _x2) {
  return _getPage.apply(this, arguments);
}

function _getPage() {
  _getPage = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(url, opts) {
    var res, buf, contentType, contentLength, str, rg, supported, charset;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return cross_fetch_1.default(url, {
              headers: {
                Accept: "text/html, application/xhtml+xml",
                "User-Agent": opts.userAgent
              }
            });

          case 2:
            res = _context2.sent;
            _context2.t0 = Buffer;
            _context2.next = 6;
            return res.arrayBuffer();

          case 6:
            _context2.t1 = _context2.sent;
            buf = _context2.t0.from.call(_context2.t0, _context2.t1);
            contentType = res.headers.get("Content-Type");
            contentLength = res.headers.get("Content-Length");

            if (!(/text\/html|application\/xhtml+xml/.test(contentType) === false)) {
              _context2.next = 12;
              break;
            }

            throw new unexpectedError_1.default(Object.assign({}, unexpectedError_1.default.EXPECTED_HTML, {
              info: {
                contentType: contentType,
                contentLength: contentLength
              }
            }));

          case 12:
            // no charset in content type, peek at response body for at most 1024 bytes
            str = buf.slice(0, 1024).toString();

            if (contentType) {
              rg = /charset=([^;]*)/i.exec(contentType);
            } // html 5


            if (!rg && str) {
              rg = /<meta.+?charset=(['"])(.+?)\1/i.exec(str);
            } // html 4


            if (!rg && str) {
              rg = /<meta.+?content=["'].+;\s?charset=(.+?)["']/i.exec(str);
            } // found charset


            if (!rg) {
              _context2.next = 21;
              break;
            }

            supported = ["CP932", "CP936", "CP949", "CP950", "GB2312", "GBK", "GB18030", "BIG5", "SHIFT_JIS", "EUC-JP"];
            charset = rg.pop().toUpperCase();

            if (!supported.includes(charset)) {
              _context2.next = 21;
              break;
            }

            return _context2.abrupt("return", iconv_lite_1.decode(buf, charset).toString());

          case 21:
            return _context2.abrupt("return", buf.toString());

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getPage.apply(this, arguments);
}

function getRemoteMetadata(ctx, opts) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(metadata) {
        var target, res, contentType, contentLength, ret, data, content, oEmbedMetadata;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (ctx._oembed) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", metadata);

              case 2:
                target = url_1.resolve(ctx.url, ctx._oembed.href);
                _context.next = 5;
                return cross_fetch_1.default(target);

              case 5:
                res = _context.sent;
                contentType = res.headers.get("Content-Type");
                contentLength = res.headers.get("Content-Length");

                if (!(ctx._oembed.type === "application/json+oembed" && /application\/json/.test(contentType))) {
                  _context.next = 14;
                  break;
                }

                _context.next = 11;
                return res.json();

              case 11:
                ret = _context.sent;
                _context.next = 22;
                break;

              case 14:
                if (!(ctx._oembed.type === "text/xml+oembed" && /text\/xml/.test(contentType))) {
                  _context.next = 22;
                  break;
                }

                _context.next = 17;
                return res.text();

              case 17:
                data = _context.sent;
                content = {};
                _context.next = 21;
                return new Promise(function (resolve, reject) {
                  var parser = new htmlparser2_1.Parser({
                    onopentag: function onopentag(name, attribs) {
                      if (this._is_html) {
                        if (!content.html) {
                          content.html = "";
                        }

                        content.html += "<".concat(name, " ");
                        content.html += Object.keys(attribs).reduce(function (str, k) {
                          return str + (attribs[k] ? "".concat(k, "=\"").concat(attribs[k], "\"") : "".concat(k)) + " ";
                        }, "").trim();
                        content.html += ">";
                      }

                      if (name === "html") {
                        this._is_html = true;
                      }

                      this._tagname = name;
                    },
                    ontext: function ontext(text) {
                      if (!this._text) this._text = "";
                      this._text += text;
                    },
                    onclosetag: function onclosetag(tagname) {
                      if (tagname === "oembed") {
                        return;
                      }

                      if (tagname === "html") {
                        this._is_html = false;
                        return;
                      }

                      if (this._is_html) {
                        content.html += this._text.trim();
                        content.html += "</".concat(tagname, ">");
                      }

                      content[tagname] = this._text.trim();
                      this._tagname = "";
                      this._text = "";
                    },
                    onend: function onend() {
                      resolve(content);
                    }
                  });
                  parser.write(data);
                  parser.end();
                });

              case 21:
                ret = _context.sent;

              case 22:
                if (ret) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return", metadata);

              case 24:
                oEmbedMetadata = Object.keys(ret).map(function (k) {
                  return ["oEmbed:" + k, ret[k]];
                }).filter(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                      k = _ref3[0],
                      v = _ref3[1];

                  return schema_1.keys.includes(String(k));
                });
                metadata.push.apply(metadata, _toConsumableArray(oEmbedMetadata));
                return _context.abrupt("return", metadata);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x3) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

function getMetadata(ctx, opts) {
  return function (text) {
    var metadata = [];
    return new Promise(function (resolve) {
      var parser = new htmlparser2_1.Parser({
        onend: function onend() {
          if (this._favicon === undefined) {
            metadata.push(["favicon", url_1.resolve(ctx.url, "/favicon.ico")]);
          } else {
            metadata.push(["favicon", url_1.resolve(ctx.url, this._favicon)]);
          }

          resolve(metadata);
        },
        onopentagname: function onopentagname(tag) {
          this._tagname = tag;
        },
        ontext: function ontext(text) {
          if (this._tagname === "title") {
            // makes sure we haven't already seen the title
            if (this._title !== null) {
              if (this._title === undefined) {
                this._title = "";
              }

              this._title += text;
            }
          }
        },
        onopentag: function onopentag(tagname, attribs) {
          if (opts.oembed && attribs.href) {
            // handle XML and JSON with a preference towards JSON since its more efficient for us
            if (tagname === "link" && (attribs.type === "text/xml+oembed" || attribs.type === "application/json+oembed")) {
              if (!ctx._oembed || ctx._oembed.type === "text/xml+oembed") {
                // prefer json
                ctx._oembed = attribs;
              }
            }
          }

          if (tagname === "link" && attribs.href && (attribs.rel === "icon" || attribs.rel === "shortcut icon")) {
            this._favicon = attribs.href;
          }

          var pair;

          if (tagname === "meta") {
            if (attribs.name === "description") {
              pair = ["description", attribs.content];
            } else if (attribs.name === "keywords") {
              var keywords = attribs.content.replace(/^[,\s]{1,}|[,\s]{1,}$/g, "") // gets rid of trailing space or sommas
              .split(/,{1,}\s{0,}/); // splits on 1+ commas followed by 0+ spaces

              pair = ["keywords", keywords];
            } else if (attribs.property && schema_1.keys.includes(attribs.property)) {
              pair = [attribs.property, attribs.content];
            } else if (attribs.name && schema_1.keys.includes(attribs.name)) {
              pair = [attribs.name, attribs.content];
            }
          }

          if (pair) {
            metadata.push(pair);
          }
        },
        onclosetag: function onclosetag(tag) {
          this._tagname = "";

          if (tag === "title") {
            metadata.push(["title", this._title]);
            this._title = "";
          } // We want to parse as little as possible so finish once we see </head>


          if (tag === "head") {
            parser.reset();
          }
        }
      });
      parser.write(text);
      parser.end();
    });
  };
}

function parse(ctx) {
  return function (metadata) {
    var parsed = {};
    var tags = [];
    var lastParent;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = metadata[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref6 = _step.value;

        var _ref5 = _slicedToArray(_ref6, 2);

        var metaKey = _ref5[0];
        var metaValue = _ref5[1];
        var item = schema_1.schema.get(metaKey); // decoding html entities

        if (typeof metaValue === "string") {
          metaValue = he_1.decode(he_1.decode(metaValue.toString()));
        } else if (Array.isArray(metaValue)) {
          metaValue = metaValue.map(function (val) {
            return he_1.decode(he_1.decode(val));
          });
        }

        if (!item) {
          parsed[metaKey] = metaValue;
          continue;
        } // special case for video tags which we want to map to each video object


        if (metaKey === "og:video:tag") {
          tags.push(metaValue);
          continue;
        }

        if (item.type === "number") {
          metaValue = parseInt(metaValue, 10);
        } else if (item.type === "url" && metaValue) {
          metaValue = url_1.resolve(ctx.url, metaValue);
        }

        if (parsed[item.entry] === undefined) {
          parsed[item.entry] = {};
        }

        var target = parsed[item.entry];

        if (item.parent) {
          if (item.category) {
            if (!target[item.parent]) {
              target[item.parent] = {};
            }

            if (!target[item.parent][item.category]) {
              target[item.parent][item.category] = {};
            }

            target = target[item.parent][item.category];
          } else {
            if (Array.isArray(target[item.parent]) === false) {
              target[item.parent] = [];
            }

            if (!target[item.parent][target[item.parent].length - 1]) {
              target[item.parent].push({});
            } else if ((!lastParent || item.parent === lastParent) && target[item.parent][target[item.parent].length - 1] && target[item.parent][target[item.parent].length - 1][item.name]) {
              target[item.parent].push({});
            }

            lastParent = item.parent;
            target = target[item.parent][target[item.parent].length - 1];
          }
        } // some fields map to the same name so once nicwe have one stick with it


        target[item.name] || (target[item.name] = metaValue);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (tags.length && parsed.open_graph.videos) {
      parsed.open_graph.videos = parsed.open_graph.videos.map(function (obj) {
        return Object.assign({}, obj, {
          tags: tags
        });
      });
    }

    return parsed;
  };
}